import test4No from './answers/no/answers-test4.json';

export const no = {
	test4: test4No,
};
